import React from "react";
import { buildReserveReportSummary } from "../shared/reserveReceipt";
export default function ReserveReportSummary({ data }) {
  if (!data || !(data.issuedMinor || data.redeemedMinor || data.cancelledIssueMinor || data.restoredRedemptionMinor)) return null;
  const money = (minor) => `${(Number(minor || 0) / 100).toLocaleString("fr-FR")} F`;
  const summary = buildReserveReportSummary(data);
  return <div className="my-4 space-y-4">
    {!!(summary.issuedMinor || summary.cancelledIssueMinor) && <section className="rounded-xl border border-amber-300/30 bg-amber-300/5 p-4">
      <h3 className="font-semibold">Consignations</h3>
      <div className="mt-3 space-y-1 text-sm text-white/80">
        {summary.lines.map((line) => <div key={line.label} className="flex justify-between gap-4">
          <span>{line.quantity}× {line.label}</span>
          <span className="whitespace-nowrap font-semibold">{money(line.valueMinor)}</span>
        </div>)}
      </div>
      <div className="mt-3 flex justify-between border-t border-white/10 pt-2 font-semibold">
        <span>Total</span><span>{money(summary.issuedMinor)}</span>
      </div>
      {!!summary.cancelledIssueMinor && <p className="mt-2 text-sm">Mises en réserve annulées : {money(summary.cancelledIssueMinor)}</p>}
    </section>}
    {!!(summary.redeemedMinor || summary.restoredRedemptionMinor) && <section className="rounded-xl border border-emerald-300/30 bg-emerald-300/5 p-4">
      <h3 className="font-semibold">Réserves utilisées</h3>
      <div className="mt-3 flex justify-between border-t border-white/10 pt-2 font-semibold">
        <span>Total</span><span>{money(summary.redeemedMinor)}</span>
      </div>
      {!!summary.restoredRedemptionMinor && <p className="mt-2 text-sm">Montants recrédités après annulation : {money(summary.restoredRedemptionMinor)}</p>}
    </section>}
  </div>;
}
